<script setup>

</script>

<template>
  <div class="container">
    <div class="header"><span class="login"><a
        href="/register">还没有账号请点击注册~</a></span></div><!-- end header -->
    <hr>
    <form>
      <input type="text" name="username" id="username" placeholder="用户名/邮箱">
      <input type="password" name="password" id="password" placeholder="密码">
      <input type="submit" value="登录"></form>
  </div>
</template>

<style scoped>
.container {
  margin: 0 auto;
  width: 500px;
  height: 500px;
  background: white;
  border-radius: 500px;
  border: 8px solid rgba(245,245,245,0.5);
  -webkit-background-clip: padding-box;
  background-clip: padding-box
}
</style>